import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconMacintosh: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconMacintosh"><Path fillRule="evenodd" clipRule="evenodd" d="M4 2H20V19H19V22H5V19H4V2ZM6 17V4H18V17H6ZM7 5H17V13H7V5ZM13 14H17V16H13V14Z" fill="currentColor"/></CentralIconBase>;
});

export default IconMacintosh;
